module.exports = __webpack_public_path__ + "static/media/003.92301f13.jpg";